module.exports = __webpack_public_path__ + "plus-2021jump/images/naruto_02.7d49729.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/items/naruto_02.jpg
// module id = vFhw
// module chunks = 0